import React from "react";
import mySvg from "../../image/meesok.png";
import "./Navbar.css";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LanguageIcon from "@mui/icons-material/Language";
import { useLanguage } from "../../common/i18n/LanguageContext";

function Navbar() {
  const user = localStorage.getItem("user");
  const pos = localStorage.getItem("position");
  const subuser = localStorage.getItem("subuser");
  const { lang, setLang, t } = useLanguage();

  const handleLogout = () => {
    Swal.fire({
      title: t("logout_confirm_title"),
      showCancelButton: true,
      confirmButtonText: t("logout_confirm_yes"),
      cancelButtonText: t("logout_confirm_no"),
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.reload();
        // Perform any additional logout actions here
      }
    });
  };

  return (
    <div className="flex flex-col font-body">
      <div className="nav w-[1080px] md:w-full">
        <div className="nav-sheen"></div>
        <div className="nav-logo z-40 w-[10%] h-[10%]">
          <img src={mySvg} alt="" className="mt-7" />
        </div>
        <div className="nav-inner">
          <div className="nav-top">
            <div className="flex flex-row mt-3">
              <AccountBoxIcon className="text-brand-gold-300 mr-1" />
              <p className="text-white text-[10px] font-bold underline-offset-auto mr-4 hover:text-brand-gold-200 md:text-white text-sm font-bold underline-offset-auto mr-4 hover:text-brand-gold-200 sm:text-white text-sm font-bold underline-offset-auto mr-4 hover:text-brand-gold-200">
                {t("navbar_welcome")} {pos === "sub_account" ? subuser : user}
              </p>
            </div>
            <div className="nav-top-right">
              <div className="px-2 py-1">
                <div className="inline-flex items-center gap-1 mr-4">
                  <LanguageIcon
                    className="text-brand-gold-300"
                    sx={{ fontSize: 14 }}
                  />
                  <select
                    value={lang}
                    onChange={(e) => setLang(e.target.value)}
                    className="text-[10px] font-bold bg-transparent text-brand-blue-100 border border-brand-blue-100/40 rounded px-1 py-0.5 focus:outline-none focus:text-white focus:border-brand-gold-300"
                  >
                    <option className="text-slate-800" value="th">
                      ไทย
                    </option>
                    <option className="text-slate-800" value="en">
                      EN
                    </option>
                    <option className="text-slate-800" value="lo">
                      ລາວ
                    </option>
                    <option className="text-slate-800" value="zh">
                      中文
                    </option>
                    <option className="text-slate-800" value="vi">
                      VI
                    </option>
                  </select>
                </div>
                <Link
                  to="/"
                  className="text-white text-[10px] font-bold underline-offset-auto mr-4 hover:text-brand-gold-200 md:text-white text-sm font-bold underline-offset-auto mr-4 hover:text-brand-gold-200 sm:text-white text-sm font-bold underline-offset-auto mr-4 hover:text-brand-gold-200"
                >
                  {t("navbar_home")}
                </Link>
                <Link
                  to="/"
                  onClick={handleLogout}
                  className="text-rose-300 text-[10px] font-bold underline-offset-auto mr-4 hover:text-brand-gold-200 md:text-rose-300 text-sm font-bold underline-offset-auto mr-4 hover:text-brand-gold-200 sm:text-rose-300 text-sm font-bold underline-offset-auto mr-4 hover:text-brand-gold-200"
                >
                  {t("navbar_logout")}
                </Link>
              </div>
            </div>
          </div>
          <div className="nav-bot w-full mt-5">
            <div className="nav-bot-left w-full">
              <div className="notice-head md:z-30 z-30">
                <h5 className="text-[8px] md:text-[13px] font-semibold font-heading text-brand-gold-200 ml-1 break-words py-2 md:py-0">
                  {t("navbar_notice")}
                </h5>
              </div>
              <div className="w-full md:w-full h-5 bg-brand-gold-100 rounded-r-lg z-20 md:mt-0 mt-2">
                <h5 className="text-[8px] md:text-[12px] font-semibold text-brand-ink-onGold ml-1 break-words running-text py-2 md:py-0">
                  {t("navbar_notice_text")}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-[1080px] md:w-full h-1 bg-brand-gold-400 border-solid"></div>
    </div>
  );
}

export default Navbar;
